import { render } from "./ShoppingCartItem.vue?vue&type=template&id=80e80b8a"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=js"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__